import {GameState, PerformActionRequest} from "../../../shared/types";
import {getJsonApi, postJsonApi, userMethod} from "../helpers";

export async function getState(): Promise<GameState | undefined> {
    return getJsonApi<GameState>("state");
}

export async function performAction(
    actionAlias: string,
    objectAliases?: string[]
): Promise<GameState | undefined> {
    try {
        return postJsonApi<GameState, PerformActionRequest>("action", {
            action: actionAlias,
            objects: objectAliases
        });
    } catch {
        return undefined;
    }
}

export async function gameOverRequest(): Promise<GameState | undefined> {
    return getJsonApi<GameState>("game/over");
}

export async function leaderboardRequest(): Promise<any> {
    return getJsonApi("leaderboard");
}

export async function startGame(): Promise<any> {
    return getJsonApi("start");
}


export async function registerUser(
    username: string,
    password: string
): Promise<Response | undefined> {
    return userMethod("POST", "register", {
        username: username,
        password: password
    });
}

export async function loginUser(
    username: string,
    password: string
): Promise<Response | undefined> {
    return userMethod("POST", "login", {
        username: username,
        password: password
    });
}

export async function postScore(
    score: number
): Promise<Response | undefined> {
    return postJsonApi("post-score", {
        score: score,
    });
}
